import React, { FC } from 'react';

import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import { LocationSuggestionFragment } from '@websky/graphql';
import DesktopDirections from './DesktopDirections/DesktopDirections';
import MobileDirections from './MobileDirections/MobileDirections';

interface Props {
	cities?: LocationSuggestionFragment[];
}

const DirectionsSection: FC<Props> = ({ cities }) => {
	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	return (
		<>
			{!isMobile && <DesktopDirections cities={cities} />}

			{isMobile && <MobileDirections cities={cities} />}
		</>
	);
};

export default DirectionsSection;
